import React, { useEffect, useState } from 'react';
import * as PouchDB from 'pouchdb';
import PouchDBAuthentication from 'pouchdb-authentication';
import { Database } from '../../services/serviceDB';
import { ChangeModal, ConfirmModal } from '../Modals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
PouchDB.default.plugin(PouchDBAuthentication)

var userDB = new Database("_users", false)

export default function ListUsers() {
    // List users
    const [users, setUsers] = useState<any>({})
    
    // MODALS 
    // (dont) display modals
    const [showConfirm, setShowConfirm] = useState(false)
    const [showChange, setShowChange] = useState(false)
    // handler function to callback
    const [handler, setHandler] = useState({})
    // description for modal
    const [description, setDescription] = useState("")
    // the type of modification
    const [toModify, setToModify] = useState<any>()
    // username with which call the db
    const [userName, setUserName] = useState<any>()

    useEffect(() => {
        userDB.remote_database.allDocs({include_docs:true, attachments:true}).then(result => {
            setUsers(result.rows)
        })
    }, [])

    const handleChangeUserName = (oldUserName, newUserName) => {
        userDB.remote_database.changeUsername(oldUserName, newUserName, function(err) {
            window.location.reload()
          })
    }
    const handleChangeUserPassword = (userName, newPassword) => {
        userDB.remote_database.changePassword(userName, newPassword, function(err) {
            window.location.reload()
          })
    }
    const handleChangeUserRole = (userName, newRole) => {
        userDB.remote_database.putUser(userName, {
            roles : [newRole]
          }, function (err, response) {
            window.location.reload()
          });
    }
    const handleDeleteUser = (userName) => {
        userDB.remote_database.deleteUser(userName, function (err, response) {
            window.location.reload()
          });
          
    }


    return (
        <>
            <h1>Membres</h1>
            <div>
                <table className='container'>
                    <thead>
                        <tr>
                            <th>Nom de compte</th>
                            <th>Mot de passe</th>
                            <th>Roles</th>
                            <th>Date de création</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(users).map(key => (!(users[key].id).includes("_design") ?
                        <tr className='table-body' key={key}>

                            {/* USERNAME */}
                            <th className='clickable' onClick={() => {
                                    setHandler(() => (a,b) => handleChangeUserName(a,b));
                                    setShowChange(true);
                                    setToModify("text");
                                    setUserName(users[key].doc.name);
                                    setDescription("Modifier le nom d'utilisateur: " + users[key].doc.name + " ?");
                                    }}>
                                {users[key].doc.name}
                            </th>
                            
                            {/* PASSWORD */}
                            <th className='clickable' onClick={() => {
                                    setHandler(() => (a,b) => handleChangeUserPassword  (a,b));
                                    setShowChange(true);
                                    setToModify("password");
                                    setUserName(users[key].doc.name);
                                    setDescription("Modifier le mot de passe de " + users[key].doc.name + " ?");
                                    }}>***********</th>

                            {/* USER ROLE */}
                            <th className='clickable' onClick={() => {
                                    setHandler(() => (a,b) => handleChangeUserRole  (a,b));
                                    setShowChange(true);
                                    setToModify("list");
                                    setUserName(users[key].doc.name);
                                    setDescription("Modifier le rôle de " + users[key].doc.name + " ?");
                                    }}>{users[key].doc.roles}</th>

                            {users[key].doc.created ? <th>{users[key].doc.created}</th> : <th></th>}

                            {/* DELETE */}
                            <th className='clickable' 
                                onClick={() => {
                                    setHandler(() => () => handleDeleteUser(users[key].doc.name));
                                    setShowConfirm(true);
                                    setDescription("Supprimer " + users[key].doc.name + " ?")
                                    }}>
                                <FontAwesomeIcon icon={faTrash} size="2x"/>
                            </th>
                        </tr>
                        : null
                        ))}
                    </tbody>
                </table>
            </div>


            {/* CALL CONFIRMATION MODAL */}
            <ConfirmModal 
                show={showConfirm} 
                description={description}
                close={() => setShowConfirm(false)}
                callback={handler}
            />


            {/* CALL CHANGE MODAL */}
            <ChangeModal
                show={showChange}
                description={description}
                toModify={toModify}
                userName={userName}
                close={() => setShowChange(false)}
                callback={handler}
                listchoice={["user", "website_admin"]}
            />
        </>
    )
}